import { apiEndpoints } from "../../constants";
import { BaseService } from "./baseService";

class PaypalServices extends BaseService {
  async createOrder(request_id: number) {
    const headers = {
      "Content-Type": "application/json"
    };

    return await this.post(
      apiEndpoints.PAYMENT.PAYPAL.CREATE_ORDER,
      {
        request_id
      },
      headers
    );
  }

  async captureOrder(order_id: string) {
    const headers = {
      "Content-Type": "application/json"
    };

    return await this.post(
      apiEndpoints.PAYMENT.PAYPAL.CAPTURE_ORDER,
      { order_id },
      headers
    );
  }
}

const paypalServices = new PaypalServices();
export default paypalServices;
